<template>
  <section class="bg-primary-110 flex gap-4 items-center fixed bottom-0 w-full p-4 z-30">
    <slot name="tagline">
      <h3 class="text-primary-50">
        {{ $i18nPresenter.t('Discover more features—sign up free.') }}
      </h3>
    </slot>
    <slot name="call-to-actions">
      <aha-antd-button
        type="button"
        variant="secondary"
        name="cta-login"
        v-aha-emit-action
        @click="onCtaLogin"
      >
        {{ $i18nPresenter.t('Log in') }}
      </aha-antd-button>
      <aha-antd-button
        variant="primary"
        type="button"
        name="cta-signup"
        v-aha-emit-action
        @click="onCtaSignup"
      >
        {{ $i18nPresenter.t('Sign up') }}
      </aha-antd-button>
    </slot>
  </section>
</template>
<script>
import { ROUTE_NAMES } from '@/constant/routes'

export default {
  methods: {
    onCtaLogin() {
      this.$router.push({
        name: ROUTE_NAMES.LOGIN,
        query: { redirect: window.location.href },
      })
    },
    onCtaSignup() {
      this.$router.push({
        name: ROUTE_NAMES.REGISTER,
        query: { redirect: window.location.href },
      })
    },
  },
}

</script>
